import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExport = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.375 14.375V16.25C4.375 16.7475 4.5725 17.2244 4.92438 17.5756C5.27563 17.9275 5.7525 18.125 6.25 18.125H14.375C14.8725 18.125 15.3494 17.9275 15.7006 17.5756C16.0525 17.2244 16.25 16.7475 16.25 16.25C16.25 13.4412 16.25 6.875 16.25 6.875C16.25 6.70937 16.1844 6.55 16.0669 6.43313L11.6919 2.05812C11.575 1.94062 11.4156 1.875 11.25 1.875C11.25 1.875 8.07375 1.875 6.25 1.875C5.7525 1.875 5.27563 2.0725 4.92438 2.42437C4.5725 2.77562 4.375 3.2525 4.375 3.75V9.375C4.375 9.72 4.655 10 5 10C5.345 10 5.625 9.72 5.625 9.375V3.75C5.625 3.58438 5.69063 3.425 5.80813 3.30813C5.925 3.19063 6.08438 3.125 6.25 3.125H10.9913L15 7.13375V16.25C15 16.4156 14.9344 16.575 14.8169 16.6919C14.7 16.8094 14.5406 16.875 14.375 16.875H6.25C6.08438 16.875 5.925 16.8094 5.80813 16.6919C5.69063 16.575 5.625 16.4156 5.625 16.25V14.375C5.625 14.03 5.345 13.75 5 13.75C4.655 13.75 4.375 14.03 4.375 14.375Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.625 3.125V5.625C10.625 6.66062 11.4644 7.5 12.5 7.5H15C15.345 7.5 15.625 7.22 15.625 6.875C15.625 6.53 15.345 6.25 15 6.25H12.5C12.155 6.25 11.875 5.97 11.875 5.625V3.125C11.875 2.78 11.595 2.5 11.25 2.5C10.905 2.5 10.625 2.78 10.625 3.125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.5 12.5H10C10.345 12.5 10.625 12.22 10.625 11.875C10.625 11.53 10.345 11.25 10 11.25H2.5C2.155 11.25 1.875 11.53 1.875 11.875C1.875 12.22 2.155 12.5 2.5 12.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.68312 9.81687L9.74124 11.875L7.68312 13.9331C7.43937 14.1769 7.43937 14.5731 7.68312 14.8169C7.92687 15.0606 8.32312 15.0606 8.56687 14.8169L11.0669 12.3169C11.3112 12.0731 11.3112 11.6769 11.0669 11.4331L8.56687 8.93312C8.32312 8.68937 7.92687 8.68937 7.68312 8.93312C7.43937 9.17687 7.43937 9.57312 7.68312 9.81687Z",
			fill: "currentColor"
		})
	]
});
export default SvgExport;
